// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.places-dtm[data-v-7f08f655]{margin:0 .3em}.places-dtm div.place-btn[data-v-7f08f655]{display:inline-block}.places-dtm div.place-btn>a[data-v-7f08f655],.places-dtm div.place-btn>button[data-v-7f08f655]{font-size:.85em;min-height:unset;margin:3px 2px;padding:0px 6px}@media(min-width: 769px){.places-dtm[data-v-7f08f655]{margin-right:44px}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
